import { Component } from '@angular/core';

@Component({
  selector: 'app-administrativo-clientes',
  templateUrl: './administrativo-clientes.component.html',
  styleUrls: ['./administrativo-clientes.component.scss']
})
export class AdministrativoClientesComponent {
  constructor() { }
}
